import * as actionTypes from '../consts/actionTypes';

const initialState = {
    subCategories: null,
    postSubCategory: null,
    putSubCategory: null,
    deleteSubCategory: null,
    error: null,
};

export default function subcategoryReducer(state = initialState, action) {
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SUCCESS_GET_SUBCATEGORIES]: responseToReturn('subCategories'),
        [actionTypes.SUCCESS_POST_SUBCATEGORY]: responseToReturn('postSubCategory'),
        [actionTypes.SUCCESS_PUT_SUBCATEGORY]: responseToReturn('putSubCategory'),
        [actionTypes.SUCCESS_DELETE_SUBCATEGORY]: responseToReturn('deleteSubCategory'),
        [actionTypes.ERROR_SUBCATEGORY]: errorReturn('error'),
        [actionTypes.CLEAR_REQUEST_FAILURE]: clearReducer('CLEAR_REQUEST_FAILURE', 'error'),
    };
    function responseToReturn(typeState) {
        let res = { ...state };
        if (action.response) {
            res = { ...state, [typeState]: action.response.data };
        }
        return res;
    }

    function errorReturn(typeState) {
        let res = { ...state };
        if (action.response) {
            res = { ...state, [typeState]: action.response };
        }
        return res;
    }

    function clearReducer(typeConst, typeState) {
        let res = { ...state };
        if (action.type === typeConst) {
            res = { ...state, [typeState]: null };
        }
        return res;
    }

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}